import { createContext, useContext } from 'react';

export type ToastTone = 'success' | 'error';

export interface ShowToastOptions {
  brand?: string;
  label?: string;
  preview: string;
  /** Drives the side-bar accent + default label. Defaults to 'success'. */
  tone?: ToastTone;
  onClick?: () => void;
  /** Unique toast identifier. */
  id?: string;
}

export interface ToastItem extends ShowToastOptions {
  id: string;
}

export interface ToastContextValue {
  showToast: (options: ShowToastOptions) => void;
}

export const ToastContext = createContext<ToastContextValue>({
  showToast: () => {},
});

export const useToast = () => useContext(ToastContext);
